
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Screen, SubHeader, Text, TableAdmin } from '../../../components';
import pressroomService from '../../../services/pressroom';
import PropTypes from 'prop-types';
const moment = require('moment');

const { defaultStates, baseURL } = require('../../../utils/defaults');

import {
  ContainerSocialMedia,
  IconSocialMedia,
  Textsbody,
  Pressimg,
  StyledLink,
  WorkContainer,
  RowStyled,
  ExternalIcon,
} from './styles';

import banner from '../../../assets/imgs/banner-desktop-trabalhe-conosco-v1.png';
import bannerMobile from '../../../assets/imgs/banner-mobile-trabalhe-conosco-v1.png';
import Press from '../../../assets/imgs/pressRoom.png';
class PressRoom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: window.innerWidth < 768,
      ...defaultStates(),
      innerWidth: window.innerWidth,
      valueTab: 0,
      contents: [],
      pressroom: [],
      documentsWithFiles: [], 
      documentsWithUrls: [],
    };

    this.body = this.body.bind(this);
    this.header = this.header.bind(this);
    this.updateSize = this.updateSize.bind(this);
    this.fillTable = this.fillTable.bind(this);
  }

  async componentDidMount() {
    await this.fillTable();
  }

  async fillTable() {
    const response = await pressroomService.user.getList({});
    if (response.ok && response.data) {

      const sortedResponse = response.data.sort((a, b) => {
        if (!a.postingDate) return 1;
        if (!b.postingDate) return -1;
        return moment(b.postingDate).diff(moment(a.postingDate));
      });

      const data = sortedResponse.map((i) => {
        return {
          ...i,
          postingDate: i.postingDate ? moment(i.postingDate).utc().format('DD/MM/YYYY') : '',
        };
      });

      const documentsWithFiles = data.filter(item => item.type === 'releases');
      const documentsWithUrls = data.filter(item => item.type === 'midia');

      this.setState({ 
        documentsWithFiles,
        documentsWithUrls 
      });
    } 
  }

  transformArray = (data) => {
    return data.map((item) => ({
      title: item.title || 'Documento sem título',
      url: item.url,
      postingDate: item.postingDate,
      type: item.type,
      isActive: item.isActive,
      file_id_document: item.file_id_document,
      slug: item.file_pressroom?.slug,
      urlS3: item.file_pressroom?.urlS3,
    }));
  };

  async updateSize() {
    this.setState({ innerWidth: window.innerWidth });
  }

  header() {
    return (
      <SubHeader
        image
        backgroundImage={banner}
        backgroundImageMobile={bannerMobile}
        minHeightSm={452}
        minHeight={313}
        title={'Sala de Imprensa'}
      />
    );
  }

  body = () => {
    const onCellClick = ({ row }) => {
      if (row.url) {
        const url = row.url.startsWith('http') ? row.url : `https://${row.url}`;
        window.open(url, '_blank');
      }
    };

    const onCellClickFile = ({ row }) => {
      if (row.file_id_document) {
        window.open(`${baseURL()}/api/file/${row.file_id_document}/${row.file_pressroom?.slug}`);
      }
    };

    const processedDataFiles = this.state.documentsWithFiles.map(item => ({
      ...item,
      icon: item.id ? <ExternalIcon/> : '',
    }));

    const columnsFiles = [
      { headerName: 'Releases', field: 'title',sortable: false, flex: 1 },
      { headerName: 'Acesse', field: 'icon',sortable: false, flex: this.state.mobile ? 0.25 : 0.1 ,}
    ];

    const processedDataMedia = this.state.documentsWithUrls.map(item => ({
      ...item,
      combinedField: item.postingDate ? `${item.postingDate} - ${item.title}` : item.title,
      icon: item.url ? <ExternalIcon/> : '',
    }));

    const columnsMedia = [
      { headerName: 'FGCoop Na Midia', sortable: false,field: 'combinedField', flex: 1 },
      { headerName: 'Acesse', field: 'icon',sortable: false, hide: true, flex: this.state.mobile ? 0.25 : 0.1, }

    ];

    return (
      <WorkContainer className={'mb-lg-5 pb-lg-5'}>
        <Row className={'mb-lg-4 pb-lg-2'}>
          <Col className={'d-flex flex-column'}>
            <Text heading2 noWrap textAlign={'left'} title={{ one: 'Bem-vindo(a)!' }} />
          </Col>
        </Row>

        <RowStyled className={'mb-lg-5 d-flex'}>
          <Col>
            <Textsbody>
              Esta é uma área dedicada especialmente para o atendimento de imprensa.
              <br /><br /> Caso tenha demandas específicas como entrevistas ou informações para alguma pauta,
              escreva para a nossa assessoria de imprensa, Louise Gôngora <a href='mailto:louise.gongora@fgcoop.coop.br'>louise.gongora@fgcoop.coop.br</a> ou
              entre em contato pelo telefone: <a href='tel:+5561995626503'>+55 61 9 9562-6503</a>
              <br /><br /> Siga-nos nas redes sociais
              
            </Textsbody>

            <Col className={'d-flex justify-content-start flex-column'} lg={2}>
              <ContainerSocialMedia>
                <a
                  href={'https://www.instagram.com/fgcoop.coop/'}
                  target={'_blank'}
                  rel={'noreferrer noopener'}>
                  <IconSocialMedia instagram />
                </a>
                <a
                  href={'https://www.youtube.com/@FGCoop-coop'}
                  target={'_blank'}
                  rel={'noreferrer noopener'}>
                  <IconSocialMedia youtube />
                </a>
                <a
                  href={'https://www.linkedin.com/company/fgcoop/'}
                  target={'_blank'}
                  rel={'noreferrer noopener'}>
                  <IconSocialMedia />
                </a>
                <a
                  href={'https://www.facebook.com/profile.php?id=100048824569414'}
                  target={'_blank'}
                  rel={'noreferrer noopener'}>
                  <IconSocialMedia facebook />
                </a>
              </ContainerSocialMedia>
            </Col>
          </Col>
          <Pressimg className={'d-none d-md-block'} src={Press}></Pressimg>
        </RowStyled>

        <RowStyled>
          <Col>
          <Textsbody>
            <StyledLink to={{ pathname: 'https://www.fgcoop.coop.br/informacoes' }} target="_blank">
              Acesse nossos Relatórios de Gestão
            </StyledLink>
          </Textsbody>
          </Col>
        </RowStyled>
        
        <RowStyled className={'fs-4 font-weight-bold pl-2'}> 
          <Col className={'d-flex gap-5'}>
            <a className='text-decoration-none text-dark' href='#releases'>Releases</a>
            <a className='text-decoration-none text-dark' href='#midia'>FGCoop na mídia</a>
          </Col>
        </RowStyled>

        <RowStyled className={'mb-5 pb-lg-5'} id={'resolucoes'}>
          <Row className={'mb-lg-5'}>
            <Col id={'releases'}>
              {this.state.documentsWithFiles.length > 0 && (
                <Row className="justify-content-center">
                  <Col className="mt-3">
                    <TableAdmin
                      onCellClick={onCellClickFile}
                      data={processedDataFiles}
                      columns={columnsFiles}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      rowHeight={30}
                      rowHeightMobile={30}
                      disableColumnMobile
                      headerHeightMobile={50}
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
          <Row >
            <Col id={'midia'}>
              {this.state.documentsWithUrls.length > 0 && (
                <Row className="justify-content-center">
                  <Col className="mt-3">
                    <TableAdmin
                      onCellClick={onCellClick}
                      data={processedDataMedia}
                      columns={columnsMedia}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      rowHeight={30}
                      rowHeightMobile={20}
                      disableColumnMobile
                      headerHeightMobile={50}
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </RowStyled>
      </WorkContainer>
    );
  }

  render() {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <Screen
        header={this.header}
        body={this.body}
        modalState={modalState}
        alertScreenState={alertScreenState}
        loadingState={loadingState}
      />
    );
  }
}

PressRoom.propTypes = {
  //props 
  history: PropTypes.object,
};
export default PressRoom;
